/* 
 - TODO: Explanation
*/

import { ImmutableClass, types } from "../../helpers/Util";

class AnchorProperty extends ImmutableClass {
  readonly type: string;
  readonly value: any;
  readonly self_reported: boolean | undefined; // True if the patient reported this anchor property, false if the anchor property was imported from another system or set by a clinician

  static readonly serializableFields = new Map([
    ["type", [types.string]],
    ["value", [types.string, types.object]],
    ["self_reported", [types.boolean, types.undefined]],
  ]);

  constructor(type = "", value = "", self_reported = undefined) {
    super();
    this.type = type;
    this.value = value;
    this.self_reported = self_reported;
  }

  public static isValidAnchorKey = (key: string) => {
    // Check if the key is exactly in anchorKeys
    if (anchorKeys.includes(key)) {
      return true;
    }
  
    // Check for patterns like "clinician1" or "code1"
    for (const anchorKey of anchorKeys) {
      const regex = new RegExp(`^${anchorKey}\\d+$`);
      if (regex.test(key)) {
        return true;
      }
    }
  
    // Check for keys that start with "anchor"
    return key.startsWith("anchor");
  };
}

export default AnchorProperty;

export const anchorKeys = ["anatomy", "clinician", "code", "location"];
// export const anchorKeys = [
//   "anatomy", 
//   "anatomy0", 
//   "anatomy1", 
//   "anatomy2", 
//   "anatomy3", 
//   "anatomy4", 
//   "anatomy5", 
//   "clinician", 
//   "clinician0", 
//   "clinician1", 
//   "clinician2", 
//   "clinician3", 
//   "clinician4", 
//   "clinician5", 
//   "code", 
//   "location"];